import {
  CountryEntity,
  DivisionEntity,
  DivisionTypeEnum,
  GeoPointDto,
} from "@citychallenge/api-public";
import { toGeolocation, Types } from "@citychallenge/common";
import { TransTokens } from "../i18n";
import { observable, computed } from "mobx";
import { GameStore } from "./game-store";

export class CityModel implements DivisionEntity {
  @observable
  public id!: string;

  @observable
  public name!: string;

  @observable
  public image?: string;

  @observable
  public created?: string;

  @observable
  public updated?: string;

  @observable
  public country?: CountryEntity;

  @observable
  public published?: boolean;

  @observable
  public coordinates?: GeoPointDto;

  // Unused
  public games: undefined;

  constructor(entity: DivisionEntity) {
    Object.assign(this, entity);
  }

  public type = DivisionTypeEnum.City;

  @computed
  public get centerLocation(): Types["GeoLocation"] | undefined {
    if (!this.coordinates) return undefined;
    return toGeolocation(this.coordinates.coordinates as [number, number]);
  }

  public readonly gameStore = new GameStore([]);

  @computed
  public get translatedName() {
    return TransTokens.getTranslation(this.name).interpolate();
  }

  @computed
  public get translatedCountryName() {
    return this.country?.name
      ? TransTokens.getTranslation(this.country.name).interpolate()
      : undefined;
  }

  public contains(regex: RegExp) {
    const { translatedName, translatedCountryName } = this;

    return (
      regex.test(translatedName) ||
      (translatedCountryName && regex.test(translatedCountryName))
    );
  }
}
